/*
 *  *
 *  *  * Copyright (c) 2023 Hg Digital, Acrox Bank
 *  *  *************************************************************
 *  *  *Projeto  : acrox-calculator
 *  *  *Autor    : diegobrock
 *  *  *Data     : 21/06/2023 22:25
 *  *  *Empresa  : HG digital/Acrox Bank
 *  *  *************************************************************
 *  *
 */

export class GatewayCredentials {

  clientId: string;
  secret: string;

  constructor(clientId: string, secret: string) {
    this.clientId = clientId;
    this.secret = secret;
  }
}
